import { render, staticRenderFns } from "./viewInsurePage.vue?vue&type=template&id=18c52fcf&scoped=true&"
import script from "./viewInsurePage.vue?vue&type=script&lang=js&"
export * from "./viewInsurePage.vue?vue&type=script&lang=js&"
import style0 from "./viewInsurePage.vue?vue&type=style&index=0&id=18c52fcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c52fcf",
  null
  
)

export default component.exports